export default __webpack_public_path__ + "static/media/04.6f57402e.png";